/** @jsxImportSource @emotion/react */
import React from 'react';
import { SalesAssistantMainMenu } from './SalesAssistantMainMenu';
import style from './page.style';
import OnboardingScreens from './components/OnboardingScreens';

interface PageProps {
  children: JSX.Element;
}

export const SalesAssistantPage = (props: PageProps): JSX.Element => {
  const { children } = props;
  return (
    <div css={style.page}>
      <div css={style.appContainer}>
        <OnboardingScreens />
        <div css={style.container}>{children}</div>
        <SalesAssistantMainMenu />
      </div>
    </div>
  );
};
